import Script from 'next/script';
import { GoogleAnalyticsGroup } from '../../../core/constants';
import testIds from './testIds';

type Props = {
  gtmId?: string;
};

const GoogleTagManagerScript = ({ gtmId }: Props) => {
  // https://nextjs.org/docs/messages/next-script-for-ga
  return (
    <>
      <Script
        id="google-tag-manager"
        strategy="afterInteractive"
        type="text/javascript"
        data-testid={testIds.productionTag}
      >
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');`}
      </Script>
      <Script id="data-layer" strategy="afterInteractive" type="text/javascript">
        {`window.dataLayer = window.dataLayer || []; 
          function gtag(){window.dataLayer.push(arguments);} 
          gtag('js', new Date());
          ${
            process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TABIST_MEASUREMENT_ID
              ? `
                gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TABIST_MEASUREMENT_ID}', { 'groups': ['default', '${GoogleAnalyticsGroup.TABIST}'] });`
              : ''
          }
          ${
            process.env.NEXT_PUBLIC_GOOGLE_TRANSCOSMOS_AD_CONVERSION_ID
              ? `gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_TRANSCOSMOS_AD_CONVERSION_ID}', { 'groups': '${GoogleAnalyticsGroup.TRANSCOSMOS}' });`
              : ''
          }
          ${
            process.env.NEXT_PUBLIC_GOOGLE_TRANSCOSMOS_HOTEL_ADS_ID
              ? `gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_TRANSCOSMOS_HOTEL_ADS_ID}', { 'conversion_cookie_prefix' : '_ha', 'groups': '${GoogleAnalyticsGroup.TRANSCOSMOS}' });`
              : ''
          }
        `}
      </Script>
    </>
  );
};

export default GoogleTagManagerScript;
